import './App.scss';
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ICategory } from 'Components/MenuMain/MenuMainContent';
import MainLayout from 'Layouts/MainLayout/MainLayout';
import OrderLayout from 'Layouts/OrderLayout/OrderLayout';
import HeroContainer from 'Components/Hero/HeroContainer';
import CustomerLayout from 'Layouts/CustomerLayout/CustomerLayout';
import EventsPageContainer from 'Pages/EventsPage/EventsPageContainer';
import OrderStartPageContainer from 'Pages/OrderStartPage/OrderStartPageContainer';
import EventDetailPageContainer from 'Pages/EventDetailPage/EventDetailPageContainer';
import OrderDetailsPageContainer from 'Pages/OrderDetailsPage/OrderDetailsPageContainer';
import OrderPaymentPageContainer from 'Pages/OrderPaymentPage/OrderPaymentPageContainer';
import BannerAboutContainer from 'Components/BannerAbout/BannerAboutContainer';
import BannerECommerceContainer from 'Components/BannerECommerce/BannerECommerceContainer';
import BannerBookingsAndAgentsContainer from 'Components/BannerBookingsAndAgents/BannerBookingsAndAgentsContainer';
import BannerNewsAndSocialMediaContainer from 'Components/BannerNewsAndSocialMedia/BannerNewsAndSocialMediaContainer';
import OrderConfirmationPageContainer from 'Pages/OrderConfirmationPage/OrderConfirmationPageContainer';
import OrderHistoryPageContainer from 'Pages/OrderHistoryPage/OrderHistoryPageContainer';
import TicketPageContainer from 'Pages/TicketPage/TicketPageContainer';
import PickSeatManuallyContainer from 'Components/PickSeatManually/PickSeatManuallyContainer';
import InfoPageContainer from 'Pages/InfoPage/InfoPageContainer';
import OrderDeniedPageContainer from 'Pages/OrderDeniedPage/OrderDeniedPageContainer';
import ScrollToTop from 'Components/Shared/ScrollToTop/ScrollToTop';
import InfoAgentsContainer from 'Components/InfoAgents/InfoAgentsContainer';
import CookiesPopupContainer from 'Components/CookiesPopup/CookiesPopupContainer';
import InfoOrganizerPageContainer from 'Pages/InfoOrganizerPage/InfoOrganizerPageContainer';
import InfoVoucherPageContainer from 'Pages/InfoVoucherPage/InfoVoucherPageContainer';
import InfoTermsPageContainer from 'Pages/InfoTermsPage/InfoTermsPageContainer';
import InfoGroupBookingPageContainer from 'Pages/InfoGroupBookingPage/InfoGroupBookingPageContainer';
import TryggEHandel from 'Components/TryggEHandel/TryggEHandel';

interface IProps {
  categories: ICategory[];
}

const App: React.SFC<IProps> = ({ 
  categories = [],
}) => (
  <div className='app'>
    <CookiesPopupContainer />

    <Switch>
      { /* Events Page (Start) */ }
      <MainLayout path='/' exact={ true }>
        <ScrollToTop>
          <HeroContainer />
          <EventsPageContainer />
          <BannerNewsAndSocialMediaContainer />
          <BannerAboutContainer />
          <BannerBookingsAndAgentsContainer />
          <BannerECommerceContainer />
        </ScrollToTop>
      </MainLayout>

      { /* Events Page (By category) */ }
      { categories.map(c => 
        <MainLayout title={ c.displayName } key={ c.id } path={ c.localPath } exact={ true }>
          <ScrollToTop>
            <EventsPageContainer />
            <BannerNewsAndSocialMediaContainer />
            <BannerECommerceContainer />
          </ScrollToTop>
        </MainLayout>)
      }

      { /* Search Result Page */ }
      <MainLayout path='/search/:searchQuery' exact={ true }>
        <ScrollToTop>
          <EventsPageContainer />
          <BannerNewsAndSocialMediaContainer />
          <BannerECommerceContainer />
        </ScrollToTop>
      </MainLayout>

      { /* Event Page */ }
      <MainLayout path='/events/:eventID' >
        <ScrollToTop>
          <EventDetailPageContainer />
        </ScrollToTop>
      </MainLayout>
      
      { /* Customer Booking History */ }
      <CustomerLayout exact={ true } path='/bokningar' component={ OrderHistoryPageContainer } />

      { /* Voucher page */ }
      <MainLayout title='Presentkort' path='/order/presentkort' exact={ true }>
        <ScrollToTop>
          <InfoVoucherPageContainer />
        </ScrollToTop>
      </MainLayout>

      { /* Order Pages */ }
      <OrderLayout exact={ true } path='/order/:orderItemID' component={ OrderStartPageContainer } />
      <OrderLayout path='/order/:orderItemID/platsval/:innerSectionID' component={ PickSeatManuallyContainer } />
      <OrderLayout path='/order/:orderItemID/platsval' component={ PickSeatManuallyContainer } />
      <OrderLayout path='/order/:orderItemID/detaljer' component={ OrderDetailsPageContainer } />
      <OrderLayout path='/order/:orderItemID/betalning' component={ OrderPaymentPageContainer } />
      <OrderLayout path='/order/:orderItemID/bekraftelse' component={ OrderConfirmationPageContainer } />
      <OrderLayout path='/order/:orderItemID/felmeddelande' component={ OrderDeniedPageContainer } />

      { /* SMS Ticket */ }
      <Route exact={ true } path='/MT/:orderID/:barcode' component={ TicketPageContainer } />

      { /* Information Pages */ }

      <MainLayout title='Ombud' path='/ombud' exact={ true }>
        <ScrollToTop>
          <InfoAgentsContainer />
        </ScrollToTop>
      </MainLayout>

      <MainLayout title='Villkor' path='/villkor' exact={ true }>
        <ScrollToTop>
          <InfoTermsPageContainer />
        </ScrollToTop>
      </MainLayout>

      <MainLayout title='Arrangör' path='/arrangör' exact={ true }>
        <ScrollToTop>
          <InfoOrganizerPageContainer />
        </ScrollToTop>
      </MainLayout>

      <MainLayout title='Gruppbokning' path='/gruppbokning' exact={ true }>
        <ScrollToTop>
          <InfoGroupBookingPageContainer />
        </ScrollToTop>
      </MainLayout>

      <MainLayout title='Information' path='/information/:section' component={ InfoPageContainer } />

      <MainLayout title='Information' path='/information' exact={ true }>
        <ScrollToTop>
          <InfoPageContainer />
        </ScrollToTop>
      </MainLayout>

      <MainLayout title='Trygg e-handel' path='/tryggehandel' exact={ true }>
        <ScrollToTop>
          <TryggEHandel />
        </ScrollToTop>
      </MainLayout>

      { /* Events Page (Start) */ }
      <MainLayout path='/' exact={ false }>
        <ScrollToTop>
          <HeroContainer />
          <EventsPageContainer />
          <BannerNewsAndSocialMediaContainer />
          <BannerAboutContainer />
          <BannerBookingsAndAgentsContainer />
          <BannerECommerceContainer />
        </ScrollToTop>
      </MainLayout>

    </Switch>
  </div>
);

export default App;


// WEBPACK FOOTER //
// ./src/components/App/App.tsx